import React from "react";
import { actionSuspendLine } from "_models/redux/request-suspend-line/action";
import { connect } from "react-redux";
import { getEvents } from "_models/redux/events/action";
import { listcommentsTikets } from "_models/redux/request-list-comments/action";
import { LoadingButton } from "@mui/lab";
import ModalCustomActions from "modules/support/my-tickets/flow/detailTickets/components/actions-tickets/modalCustom";
import { ActionSuspendLineHook } from "../../hooks/actionsTicketsHooks/actionSuspendLineHook";

const SuspendLine = (props) => {
    const {
        modalOpen,
        setModalOpen,
        isLoading,
        setIsLoading,
        alert,
        setAlert,
        errorMssge,
        setErrorMssge,
        severityAlert,
        setSeverityAlert,
        handleClickSuspendLine,
        handleSubmit,
        clearFunction,
    } = ActionSuspendLineHook(props);
    return (
        <div>
            <LoadingButton
                fullWidth
                size="small"
                onClick={handleClickSuspendLine}
                variant="outlined"
                className="button"
            >
                <h4>Suspender línea</h4>
            </LoadingButton>
            {modalOpen && (
                <ModalCustomActions
                    modalOpen={modalOpen}
                    setOpenModal={setModalOpen}
                    titleModal="Suspender la línea"
                    subTitleModal="¿Está seguro que desea suspender la línea?"
                    actionRequest={handleSubmit}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    alert={alert}
                    setAlert={setAlert}
                    errorMssge={errorMssge}
                    setErrorMssge={setErrorMssge}
                    severityAlert={severityAlert}
                    setSeverityAlert={setSeverityAlert}
                    clearFunction={clearFunction}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    actionSuspendLineReducer: state.actionSuspendLine,
    events: state.events,
});
const mapDispatchToProps = {
    listcommentsTikets,
    actionSuspendLine,
    getEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuspendLine);
